import { render, staticRenderFns } from "./ProfileSettingsFormPassword.vue?vue&type=template&id=8af97460&scoped=true"
import script from "./ProfileSettingsFormPassword.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsFormPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af97460",
  null
  
)

export default component.exports